
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = [
      {
        title: Flits.t("Flits.locals.navigation.review", "Review"),
        url:'#review',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: null
      },
      {
        title: Flits.t("Flits.locals.navigation.point", "Point"),
        url:'#point',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: null
      }
    ];
      Flits(obj).each(function(index, element){
      	settings.navs.splice(index+11, 0, element); //here index means position of navigation tab, element means content for tab.
      })
    
  });
  Flits(document).on('Flits:contactUS:Loaded', function(event){  
    var data = event.detail;
    Flits.shopCountryName = 'Taiwan';
  });
  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    var data = event.detail;
    Flits.shopCountryName = 'Taiwan';
  });
  Flits(document).on('click', '.flits-menu-item a[href="#review"]', function(event){  
    StampedFn.toggleRewardsModal();
  });
  Flits(document).on('click', '.flits-menu-item a[href="#point"]', function(event){  
    StampedFn.toggleRewardsModal();
  });
}(Flits));
